import React, { Component, Fragment } from "react";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { SFRTA_RecordofDisturbanceForRailAndTrackComponentsReportSestions } from "./SFRTA_RecordofDisturbanceForRailAndTrackComponentsReportSchema";
import { TickBoxOptions } from "../../../../libraries/ReportGenerator/TickBox";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";

const { weldsInfo, getWeldInfoData } = SFRTA_RecordofDisturbanceForRailAndTrackComponentsReportSestions;

const SpecialKeyValComboBox = ({ rows, data, titleAlign, style }) => {
  const getRow = (row) => {
    const { columns, height } = row;
    return (
      <tr style={height ? { height: height } : {}}>
        {columns.map((property, i) => {
          const { title, titleColSpan, valId, valueColSpan, formatter } = property;
          return (
            <Fragment key={i}>
              <td
                colSpan={titleColSpan}
                className={"pd-left-10px pd-right-10px bold-text"}
                style={{ textAlign: titleAlign ? titleAlign : "center" }}
              >
                {`${title}:`}
              </td>
              <td colSpan={valueColSpan} className={"pd-left-10px pd-right-10px text-left"}>
                {formatter ? formatter(data[valId]) : data[valId]}
              </td>
            </Fragment>
          );
        })}
      </tr>
    );
  };

  return (
    <div style={style ? style : {}}>
      <table style={{ paddingLeft: "35px", width: "100%", paddingRight: "35px" }}>
        <tbody>
          {rows.map((row) => {
            return getRow(row);
          })}
        </tbody>
      </table>
    </div>
  );
};

function createGroups(arr, perGroup) {
  const numGroups = Math.ceil(arr.length / perGroup);
  return new Array(numGroups).fill("").map((_, i) => arr.slice(i * perGroup, (i + 1) * perGroup));
}

const SectionHeader = ({ title }) => {
  return <div style={{ padding: "0 10px 10px", fontSize: "20px", fontWeight: 600 }}>{title}</div>;
};

const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { location, user, date, formSummary, isMaintenance } = reportData;
  if (!formSummary) formSummary = {};

  let data = {
    location: location,
    user: user ? user.name : "",
    reportDate: dataFormatters.dateFormatter(date),
    ...formSummary,
  };

  let reportTitle=reportData.isMaintenance ? "MR Number" : "Title"
  let formValue=reportData.isMaintenance ?  reportData.formSummary && reportData.formSummary.formId ? reportData.formSummary.formId : null : "N/A"

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection
        title="Appendix 7 - SFRC Record of Disturbance for Rail & Track Components"
        {...props}
        centerTitle={true}
        isMaintenance={isMaintenance}
      />
      <ReportInfoSection
        fontSizeOverride={"20px"}
        rows={[
          {
            col1: {
              title: reportTitle,
              value: reportData.title,
            },
            col2: {
              title: "Form ID",
              value: formValue,
            },
          },
        ]}
      />
      <span className="spacer"></span>
      <SpecialKeyValComboBox
        data={data}
        titleAlign={"left"}
        style={{ fontSize: "20px" }}
        rows={createGroups(
          [
            { title: "Track Disturbance Number", valId: "tno" },
            { title: "Weld Numbers", valId: "weldno" },
            { title: "Name", valId: "user" },
            { title: "Track", valId: "track" },
            { title: "Date", valId: "reportDate" },
            { title: "Prefix/MP", valId: "prefix" },
            { title: "Time", valId: "time", formatter: dataFormatters.convert24HourFormattedTimeToAMPM },
            { title: "Side", valId: "side" },
            { title: "Defect Number", valId: "defno" },
            { title: "Defect Type", valId: "dtype" },
          ],
          2,
        ).map((row) => ({ columns: row.map((property) => ({ ...property, titleColSpan: 5, valueColSpan: 5 })) }))}
      />
      <SpecialKeyValComboBox
        data={data}
        titleAlign={"left"}
        style={{ fontSize: "20px" }}
        rows={createGroups(
          [
            { title: "Rail Temperature", valId: "rtemp" },
            { title: "Distance between witness marks before you cut the rail", valId: "dbwmbcr" },
            { title: "Rail Gap", valId: "rgap" },
            { title: "Distance between witness marks after you cut the rail", valId: "dbwmacr" },
            { title: "Neutral Temp Before", valId: "ntemp" },
            { title: "How much rail added", valId: "ahm" },
            { title: "Change in temp required to get to 105 degrees", valId: "ctrgd" },
            { title: "How much rail removed", valId: "rhm" },
            { title: "Length of rail to be removed", valId: "lorr" },
            { title: "Welds made", valId: "wmade", formatter: (val) => TickBoxOptions(["Yes", "No"], val) },
            { title: "Calculated Neutral Temp at weld completion", valId: "cntwc" },
            { title: "Was the weld a pulled weld", valId: "wwpd", formatter: (val) => TickBoxOptions(["Yes", "No"], val) },
          ],
          2,
        ).map((row) => ({ columns: row.map((property) => ({ ...property, titleColSpan: 5, valueColSpan: 5 })) }))}
      />

      <table className="table-bordered" style={{ fontSize: "20px" }}>
        <ReportTableSectionRenderer section={weldsInfo} rowsData={getWeldInfoData(data)} />
      </table>

      <SectionHeader title={"Comments"} />
      <div style={{ border: "2px solid", padding: "5px", fontSize: "20px", height: "100px" }}>{data.com}</div>
      <div style={{ textAlign: "center", fontSize: "17px", fontWeight: 600 }}>
        <div>MARK RAIL = WELD# - WELDER'S INITIALS - DATE - MP - RAIL TEMP - ADJUSTMENT (RAIL ADDED OR REMOVED) - WITNESS MARKS</div>
        <div>Turn in original Weld Information Report into the Office Daily and Retain a Copy of Your Reports</div>
      </div>
    </div>
  );
};

const SFRTA_RecordofDisturbanceForRailAndTrackComponentsReport = (props) => {
  const { inspec } = props;
  const isMaintenance = props.isMaintenance ? props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
  const title = inspec.title ? inspec.title : null;

  let formSummaries = isMaintenance
    ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, ["sfrta_m_weldForm"])
    : ReportGeneratorUtils.getInspectionAppForms(inspec, ["sfrta_i_weldForm"]);

  return formSummaries.map((summary, _i) => (
    <ReportView
      {...props}
      reportData={{
        formSummary: summary,
        location: isMaintenance ? ReportGeneratorUtils.getMaintenanceLocation(inspec) : ReportGeneratorUtils.getInspectionLocation(inspec),
        date: ReportGeneratorUtils.getInspectionDate(inspec),
        user: ReportGeneratorUtils.getInspectionUser(inspec),
        isMaintenance: isMaintenance,
        title: title,
      }}
    />
  ));
};

export default SFRTA_RecordofDisturbanceForRailAndTrackComponentsReport;



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/RecordofDisturbanceForRailAndTrackComponentsReport/index.jsx